import { BloodlineListScreen } from '../features/bloodlines/screens/BloodlineListScreen';

export const BloodlineListPage = () => <BloodlineListScreen />;
